import { render, staticRenderFns } from "./templateSetupSonSon.vue?vue&type=template&id=07a5593b&scoped=true&"
import script from "./templateSetupSonSon.vue?vue&type=script&lang=js&"
export * from "./templateSetupSonSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a5593b",
  null
  
)

export default component.exports